import Vue from 'vue'
import App from './App'
import App_p from './App_p'
import router from './router'
import elementUi from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/js/outsideClick'
import progressive from 'progressive-image/dist/vue'
import 'progressive-image/dist/index.css'
import BaiduMap from 'vue-baidu-map'
import axios from 'axios'

Vue.prototype.$axios = axios;
axios.defaults.baseURL = '';
axios.defaults.headers.post['Content-Type'] = 'Content-Type:application/x-www-form-urlencoded; charset=UTF-8'

Vue.use(BaiduMap, {
  ak: "rQxHPQX1ua21rWnXzTbUh5KSSUbnefxR"
})
Vue.config.productionTip = false
Vue.use(elementUi)
Vue.use(progressive, {
  removePreview: true,
  scale: true
})
/* eslint-disable no-new */
let type = 'App';
if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
  Vue.prototype.$pc = false
  // Vue.prototype.$vConsole = new Vconsole()
  localStorage.setItem('pc',Vue.prototype.$pc)
  type='App_p';
} else {
  Vue.prototype.$pc = true
  let winWidth = document.documentElement.offsetWidth ||
  document.body.offsetWidth
  winWidth = winWidth < 1366 ? 1366 : winWidth
  let oHtml = document.getElementsByTagName('html')[0]
  oHtml.style.fontSize = 100 * winWidth / 1920 + 'px'
  window.addEventListener('resize', function () {
      let winWidth = document.documentElement.offsetWidth || document.body.offsetWidth
      winWidth = winWidth < 1366 ? 1366 : winWidth
      let oHtml = document.getElementsByTagName('html')[0]
      oHtml.style.fontSize = 100 * winWidth / 1920 + 'px';
  })
  localStorage.setItem('pc',Vue.prototype.$pc)
  type='App';
}
if(type=='App'){
  new Vue({
    el: '#app',
    router,
    // store,
    components: { App },
    template: '<App/>'
  })
}else{
  new Vue({
    el: '#app',
    router,
    // store,
    components: { App_p },
    template: '<App_p/>'
  })
}

// vue原型挂载 - 是否PC端



// WEBPACK FOOTER //
// ./src/main.js